import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DocumentStateResponseType } from 'src/app/types/response/document-state.response.type';
import { BaseService } from 'src/app/services/base.service';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DestroyRef } from '@angular/core';
import { DOC_STATE } from 'src/app/constants/endpoint.const';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-document',
  standalone: false,
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
})
export class DocumentComponent {
  loading: boolean = true;
  packageUser: string = '';
  isVisible: boolean = !localStorage.getItem('hasSeenDocInfoModal');
  docState: DocumentStateResponseType[] = [];
  private message = inject(NzMessageService);
  private baseService = inject(BaseService);
  private destroyRef = inject(DestroyRef);
  private profileService = inject(ProfileService);

  ngOnInit(): void {
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.packageUser = String(this.profileService.getRoLevel() || '1');
    this.profileService.getRoLevel$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((lvl) => {
        this.packageUser = String(lvl || '1');
      });
    this.getDocState();
  }

  isVisibleChange(event: boolean) {
    this.isVisible = event;
  }

  getDocState() {
    this.baseService.getData(DOC_STATE)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res: ResponseCustomType<DocumentStateResponseType[]>) => {
          this.docState = res.data
        },
        (err) => {
          this.message.create('error', err.error.data.errors || 'Failed to get document state');
        }
      );
  }

  get shippingDocState(): DocumentStateResponseType[] {
    return this.docState.filter(item => item.service_types === 'shipping_delivery');
  }

  get paymentDocState(): DocumentStateResponseType[] {
    return this.docState.filter(item => item.service_types === 'payment_service');
  }

  get qrislyDocState(): DocumentStateResponseType[] {
    return this.docState.filter(item => item.service_types === 'qrisly');
  }
}
